function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "required"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { t } from "ttag";
import { Typography } from "antd";
var Text = Typography.Text;
var Label = function(param) {
    var children = param.children, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_info = param.info, info = _param_info === void 0 ? null : _param_info;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        disabled: disabled,
        strong: true,
        style: {
            display: "block"
        }
    }, children, isRequired && /*#__PURE__*/ React.createElement(Text, {
        disabled: true,
        strong: false,
        style: {
            fontWeight: 100,
            fontStyle: "italic",
            paddingLeft: "5px"
        }
    }, "(".concat(t(_templateObject()), ")"))), info && /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, info));
};
export default Label;
